import { Component, ErrorInfo, ReactNode } from 'react';
import { sendAnalyticsEvent } from '../services/analyticsClient';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class AnalyticsErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    sendAnalyticsEvent({
      event_name: 'frontend_error',
      properties: {
        error_type: 'react_error_boundary',
        message: error.message,
        component_stack: (info.componentStack || '').slice(0, 200),
      },
      error_message: error.message,
    });
  }

  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}
